/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useState} from "react";

import {useDispatch} from "react-redux";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";

import ApplicationApiContext from "@Contexts/Api";


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";
import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";

import {TERMINAL_INTERFACE} from "@Services/Application/Interfaces/Terminals/Terminal";

import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";


import {Button, Col, Form, Row} from "react-bootstrap";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";


type AddFavouriteTerminalProps = {
    TERMINALS_LIST: TERMINAL_INTERFACE[] | null;
    TERMINALS_LIST_HANDLER(eventType: string, terminalId?: string | null): void;
};


export const AddFavouriteTerminalComponent: React.FC<AddFavouriteTerminalProps> = ({
    TERMINALS_LIST     = null, TERMINALS_LIST_HANDLER = null
}): JSX.Element | null => {


    /** @const Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    /** @const {UserInterface | null} Application Logged User (from Global Store Object) */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;

    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const [selectedTerminalId, setSelectedTerminalId] = useState("0");
    const [addTerminalToFavoritesMessage, setAddTerminalToFavoritesMessage] = useState<string | null>(null);

    const changeSelectedTerminalId = (terminalId: string): void => {
        setAddTerminalToFavoritesMessage(null);
        setSelectedTerminalId(terminalId);
    }

    const changeAddTerminalToFavoritesMessage = (message: string | null): void => {
        setSelectedTerminalId("0");
        setAddTerminalToFavoritesMessage(message);
    }


    useEffect(() => {
        return () => {
            setSelectedTerminalId("0");
            setAddTerminalToFavoritesMessage(null);
        };
    }, []);


    if (!TERMINALS_LIST?.length || !TERMINALS_LIST_HANDLER) return null;


    const TerminalsList = TERMINALS_LIST.map((terminal: TERMINAL_INTERFACE, i: number) => {
        const {TerminalNo: terminalId, TerminalName: terminalName} = terminal;
        return (
            <option key={terminalId} value={terminalId}>{terminalName}</option>
        );
    });


    const addTerminalToFavoritesRequestHandler = async () => {

        /* Check if Monitory Note ID, API URL Present, User Logged */
        if (!REST_API_URL || !LOGGED_USER?.userID) return; // No Valid Data - Stop

        /** @const ADD_TERMINAL_API_URL Terminals List REST API Endpoint URL */
        const ADD_TERMINAL_API_URL: string = REST_API_URL + "/Terminal/Favorite";

        /** @const ADD_TERMINAL_REQUEST_DATA Terminals List Request Data Object */
        const ADD_TERMINAL_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID, // Logged User ID
            TerminalNo: selectedTerminalId // Data Return Mode - Simplified
        };

        try {

            const ADD_TERMINAL_RESPONSE = await REST_API_REQUEST(
                ADD_TERMINAL_API_URL,
                ADD_TERMINAL_REQUEST_DATA,
                REST_API_REQUEST_TOKEN
            );

            if (ADD_TERMINAL_RESPONSE.status === 204) {
                TERMINALS_LIST_HANDLER("add", selectedTerminalId);
            } else {
                if (ADD_TERMINAL_RESPONSE.status === 409) {
                    const ERROR: HTTP_ERROR_RESPONSE_INTERFACE = await ADD_TERMINAL_RESPONSE.json();
                    changeAddTerminalToFavoritesMessage(ERROR.UserMessage);
                } else {
                    changeAddTerminalToFavoritesMessage("Wystąpił nieokreślony błąd");
                }
            }

        } catch (e) {
            TERMINALS_LIST_HANDLER("error");
        }

    }


    return (
        <Col xs={12} className={"add-terminal-to-favorite add-terminal-to-favorite-component"}>
            <Row>

                <Col xs={12} className={"default-section-header"} style={{paddingLeft: 15, paddingRight: 15}}>
                    <span>{`Ulubione`}</span>
                </Col>

                {addTerminalToFavoritesMessage &&
                <ErrorMessageComponent messageText={addTerminalToFavoritesMessage} />
                }

                <Col xs={6} className={"add-favorite-terminals-list"}>
                    <Form.Control as={"select"} value={selectedTerminalId} onChange={e => changeSelectedTerminalId(e.target.value)}>
                        <option value={0}>{`- wybierz -`}</option>
                        {TerminalsList}
                    </Form.Control>
                </Col>

	            <Col xs={6} className={"add-favorite-terminals-submit"}>
		            <Button disabled={!(!!selectedTerminalId && selectedTerminalId !== "0")} variant={"primary"} onClick={addTerminalToFavoritesRequestHandler}>
			            <span>{`Dodaj do ulubionych`}</span>
		            </Button>
	            </Col>

            </Row>
        </Col>
    );

};


export default AddFavouriteTerminalComponent;
